var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "cmp cmp-product-thumb",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c(
        "div",
        { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
        [
          _c("div", { staticClass: "thumb-image" }, [
            _c(
              "div",
              { staticClass: "prop-1-1" },
              [
                _vm._t("item-image", function() {
                  return [
                    _c("category-image-carousel", {
                      ref: "categoryImageCarousel",
                      attrs: {
                        "image-urls-data": _vm._f("itemImages")(
                          _vm.item.images,
                          _vm.imageUrlAccessor
                        ),
                        alt: _vm._f("itemName")(_vm.item),
                        title: _vm._f("itemName")(_vm.item),
                        "item-url": _vm._f("itemURL")(
                          _vm.item,
                          _vm.urlWithVariationId
                        ),
                        "enable-carousel":
                          _vm.$ceres.config.item.enableImageCarousel,
                        "disable-carousel-on-mobile":
                          _vm.disableCarouselOnMobile
                      }
                    })
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm._t("store-special", function() {
            return [
              _vm.storeSpecial ||
              _vm.item.variation.bundleType === "bundle" ||
              _vm.item.item.itemType === "set"
                ? _c("item-store-special", {
                    attrs: {
                      "store-special": _vm.storeSpecial,
                      "recommended-retail-price": _vm.item.prices.rrp,
                      "variation-retail-price": _vm.item.prices.default,
                      "special-offer-price": _vm.item.prices.specialOffer,
                      "decimal-count": _vm.decimalCount,
                      "bundle-type": _vm.item.variation.bundleType,
                      "item-type": _vm.item.item.itemType
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _vm._t("item-details", function() {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "thumb-content p-2 p-lg-3 d-flex flex-wrap justify-content-between"
                },
                [
                  _c("div", { staticClass: "information" }, [
                    _vm.item.item.manufacturer.externalName != ""
                      ? _c("p", { staticClass: "manufacturer d-block mb-2" }, [
                          _vm._v(
                            _vm._s(_vm.item.item.manufacturer.externalName)
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "thumb-title mb-0",
                        class: {
                          "stretched-link":
                            _vm.$ceres.config.global.shippingCostsCategoryId ==
                            0
                        },
                        attrs: {
                          href: _vm._f("itemURL")(
                            _vm.item,
                            _vm.urlWithVariationId
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("itemName")(_vm.item))
                        ),
                        _vm._l(_vm.item.groupedAttributes, function(attribute) {
                          return _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "Ceres::Template.itemGroupedAttribute",
                                  attribute
                                )
                              )
                            )
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.item.texts.name3
                      ? _c(
                          "p",
                          {
                            staticClass: "mb-0 mt-3 addtext d-none d-md-block"
                          },
                          [_vm._v(_vm._s(_vm.item.texts.name3))]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "thumb-meta w-100" },
                    [
                      _vm._t("before-prices"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "prices d-flex flex-wrap text-lg-right flex-row-reverse flex-lg-column-reverse align-items-center mt-2 mt-lg-0"
                        },
                        [
                          _vm.item.prices.rrp &&
                          _vm.item.prices.rrp.price.value > 0 &&
                          _vm.item.prices.rrp.price.value >
                            _vm.item.prices.default.price.value
                            ? _c(
                                "div",
                                { staticClass: "price-view-port text-right" },
                                [
                                  _vm.item.prices.specialOffer
                                    ? _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.default
                                                  .unitPrice.formatted,
                                                true
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    : _c("del", { staticClass: "crossprice" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("itemCrossPrice")(
                                                _vm.item.prices.rrp.unitPrice
                                                  .formatted
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "price" },
                            [
                              _vm.item.item.itemType === "set"
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemSetPrice",
                                            { price: _vm.itemSetPrice }
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFootnote"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                                : _vm.itemGraduatedPriceisCheapestSorting
                                ? [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFromPrice",
                                            { price: _vm.itemPriceGraduated }
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFootnote"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                : _vm.itemGraduatedPricesalableVariationCount
                                ? [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFromPrice",
                                            { price: _vm.itemPriceGraduated }
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFootnote"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("specialOffer")(
                                            _vm.item.prices.default.unitPrice
                                              .formatted,
                                            _vm.item.prices,
                                            "unitPrice",
                                            "formatted"
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.itemFootnote"
                                          )
                                        ) +
                                        " "
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._t("after-prices"),
                  _vm._v(" "),
                  _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                    ? _c(
                        "div",
                        { staticClass: "category-lowest-price small" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.itemLowestPrice",
                                  {
                                    price:
                                      _vm.item.prices.default.lowestPrice
                                        .formatted
                                  }
                                )
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }